export default __webpack_public_path__ + "static/media/02.d9c9e499.png";